import {useRouter} from 'next/router';
import PropTypes from 'prop-types';
import {useCallback, useContext} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import useUserActions from '@/src/app/store/user/useUserActions';
import useLoading from '@/src/hooks/useLoading';
import useRoutePaths from '@/src/hooks/useRoutePaths';

import PopupContext from '../../../popup/utils/PopupContext';
import fetchUserAction from '../../../signUp/paymentDetails/utils/fetchUserAction';
import EditFullNamePopupLayout from '../components/EditFullNamePopupLayout';
import editFullName from '../utils/editFullName';

const EditFullNamePopup = ({firstName, lastName}) => {
  const {closePopup} = useContext(PopupContext);
  const {push} = useRouter();
  const {setUserData} = useUserActions();
  const {isLoading, setLoading} = useLoading();
  const {SIGN_IN_ROUTE} = useRoutePaths();

  const handleSubmitClick = useCallback(async (values) => {
    setLoading(true);
    const {status} = await editFullName(values);

    if (status === RESPONSE_STATUSES.SUCCESS) {
      const {status: fetchUserStatus, responseBody} = await fetchUserAction();
      setLoading(false);

      if (fetchUserStatus === RESPONSE_STATUSES.SUCCESS) {
        setUserData(responseBody);
        closePopup();
      } else {
        push(SIGN_IN_ROUTE.getLink());
      }
    }
  }, []);

  const handleCancelClick = useCallback(() => {
    closePopup();
  }, [closePopup]);

  return (
    <EditFullNamePopupLayout
      firstName={firstName}
      lastName={lastName}
      onSubmitClick={handleSubmitClick}
      onCancelClick={handleCancelClick}
      isLoading={isLoading}
    />
  );
};

EditFullNamePopup.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
};

export default EditFullNamePopup;
